export default ({ request }) => ({
    orderboardadvListApi(data = {}) {
        return request({
            url: '/ecom/orderboard/list',
            method: 'POST',
            data,
            timeout: 60000,
        })
    },
    orderboardChildListApi(data = {}) {
        return request({
            url: '/ecom/orderboard/child/list',
            method: 'POST',
            data,
        })
    },
})
